import { ajax } from 'gkSrc/utils/request'
import config from '../config'

import ENV from '@/config/ENV'
import urlAdapter from '@/config/urlAdapter'
import devCon from '@/config/defaultCon'
import store from '@/store'

export default {
  /**
   * 大会列表
   */
  getConsList (data) {
    switch (ENV.ENV) {
      case 'prod':
        return ajax({
          type: 'post',
          url: `${config.conServer}/serv/miniapp/con/get-data`,
          data
        })
      case 'test':
        return new Promise((resolve, reject) => {
          resolve({
            json: `https://static-data.geekbang.org/${devCon.con}${urlAdapter(store.state.conKeyInfo.location)}${store.state.conKeyInfo.year}/data.json`,
            status: 1
          })
        })
      case 'dev':
        return new Promise((resolve, reject) => {
          if (!devCon.devLink) {
            reject(new Error('请在 config/defaultCon 提供 devLink 字段'))
          } else {
            resolve({
              json: `${devCon.devLink}`,
              status: 1
            })
          }
        })
    }
  },
  /**
   * 获取大会数据
   */
  getConData (url) {
    return ajax({ type: 'get', url })
  }
}
